import { render, staticRenderFns } from "./Dict.vue?vue&type=template&id=c23ec4ec&"
import script from "./Dict.vue?vue&type=script&lang=js&"
export * from "./Dict.vue?vue&type=script&lang=js&"
import style0 from "./Dict.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports